export default __webpack_public_path__ + "static/media/Brain-05.927a0a1a.svg";